import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

// import { loadReport } from "../_redux/actions/documentActions";

import { loadReport } from "../_api/documentsApi";

import ToDoRows from "./ToDoRows";
import { PageLoader } from "@/_components";

import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: { paddingTop: theme.spacing(1) },
    [theme.breakpoints.down("sm")]: { paddingTop: theme.spacing(1) },
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(3),
      padding: theme.spacing(1),
    },
  },
  mainGrids: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
    },
  },
  cardHeader: {
    variant: "h1",
    fontSize: 20,
    fontWeight: 600,
  },
  headerStyling: {
    backgroundColor: "#1c355e",
    textAlign: "center",
    width:"100%",
    [theme.breakpoints.up("sm")]: { height: 44 },
    [theme.breakpoints.down("sm")]: { height: 36 },
  },
  typoStyling: {
    color: "#fff",
    [theme.breakpoints.up("sm")]: { fontSize: 20, paddingTop: 7 },
    [theme.breakpoints.down("sm")]: { fontSize: 18, paddingTop: 5 },
  },
  leftBorderStyle: {
    border: "1px solid #ccc",
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    textAlign: "center",
    alignItems: "middle",
    fontWeight: 600,
    fontSize: "large",
    boxShadow: "1px 2px 5px grey",
    paddingTop: 6,
    height: "50px",
    [theme.breakpoints.up("sm")]: {
      width: "150px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "130px",
    },
  },
  rightBorderStyle: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    fontSize: "small",
    fontWeight: 600,
    boxShadow: "1px 2px 5px grey",
    height: "50px",
    [theme.breakpoints.up("sm")]: {
      width: "120px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100px",
    },
  },
  customWidth: {
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  hideSmItem: { [theme.breakpoints.down("sm")]: { display: "none" } },
  processingNoticeHolder: {
    backgroundColor: "rgb(255,255,255)",
    width: 220,
    height: 50,
    margin: "0 10px 20px",
    borderRadius: 5,
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
  },
}));

const ToDo = ({
  user,
  documents,
  viewExample,
  reviewDocInfo,
  handleFileUpload,
  handleTemplateClick,
  canShowReport,
  handleSetCanShowReport,
  // report,
  // loadReport,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [toDoList, setToDoList] = useState([{ CurrentState: "Undefined" }]);
  const [docPath, setDocPath] = useState("");
  const [loadingDocPath, setLoadingDocPath] = useState(false);
  const [appointmentID, setAppointmentID] = useState(null);
  const [jurisdictionID, setJurisdictionID] = useState(null);
  const [locationID, setLocationID] = useState(null);
  const [reportType, setReportType] = useState(null);
  const [reportName, setReportName] = useState(null);
  const [vehicleID, setVehicleID] = useState(null);
  const [report,setReport]=useState(null)


  useEffect(() => {
    if (
      documents !== null &&
      documents !== undefined &&
      documents[0] !== undefined
    ) {
      if (
        documents[0].CurrentState !== "Undefined" &&
        documents[0].CurrentState !== "None"
         
      ) {
        let todoDocuments = documents.filter((x) => x.complete === false);
        if (todoDocuments.length === 0) {
          setToDoList([{ CurrentState: "None" }]);
        } else {
          setToDoList(todoDocuments);
        }
      }
    }
  }, [documents]);

  useEffect(() => {
    setDocPath("");
    if (
      report !== null &&
      report[0] !== undefined &&
      report[0].CurrentState !== "Undefined" &&
      report[0].CurrentState !== "None" &&
      canShowReport === true
    ) {
      setDocPath(`data:application/pdf;base64,${report[0].pdfDocument}`);
      // let linkSource = `data:application/pdf;base64,${report[0].pdfDocument}`;
      reviewDocInfo(
        report[0].id,
        // linkSource,
        appointmentID,
        jurisdictionID,
        locationID,
        reportType,
        reportName,
        vehicleID
      );
    }
  }, [report]);

  const signatureClick = (e, documentObject) => {
    e.stopPropagation(); // is this necessary?
    handleSetCanShowReport(true); // is this necessary?
    setReportType(documentObject.type); // is this necessary?
    setReportName(documentObject.reportName); // is this necessary?
    handleTemplateClick(documentObject);
  };

  const handleReviewClick = (
    e,
    clientID,
    appointmentID,
    jurisdictionID,
    locationID,
    id,
    type,
    reportName,
    languageID,
    vehicleID
  ) => {
    e.stopPropagation();
    handleSetCanShowReport(true);
    setAppointmentID(appointmentID);
    setJurisdictionID(jurisdictionID);
    setLocationID(locationID);
    setReportType(type);
    setReportName(reportName);
    setVehicleID(vehicleID);

    let currentData = {
      clientID: clientID,
      appointmentID: appointmentID,
      jurisdictionID: jurisdictionID,
      locationID: locationID,
      reportId: id,
      languageID: languageID,
      vehicleID: vehicleID,
    };

    if (docPath === "") {
      setLoadingDocPath(true);
    loadReport(currentData).then((x)=>{
      setReport(x)
    }).catch((e)=>{
      console.log('errror',e)
    });
    }
  };

  // console.log('documents',documents)

  return (
    <div className={classes.root}>
      {loadingDocPath === true ? (
        <Grid
          container
          direction="row"
          justifyContent="center"
          style={{ marginTop: 50 }}
        >
          <PageLoader />
        </Grid>
      ) : (
        <>
          <Grid container direction="column">
            <Grid item className={classes.mainGrids}>
              <Typography className={classes.cardHeader}>
                {/* {t("documents.ToDO")} */}
              </Typography>
              {toDoList === undefined ||
              toDoList[0].CurrentState === "Undefined" ||
              toDoList[0].CurrentState === "None" ||
              toDoList.length === 0 ? null : (
                <>
                  <Grid sx={{ display:'flex',justifyContent:'center' }}>
                    <Grid className={classes.customWidth}>
                      <Grid container className={classes.headerStyling}>
                        <Grid item xs={4} sm={3} md={4}>
                          <Typography
                            color="secondary"
                            className={classes.typoStyling}
                          >
                            {t("documents.formHeader")}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={2} className={classes.hideSmItem} md={4}>
                          <Typography
                            color="secondary"
                            className={classes.typoStyling}
                          >
                            {t("documents.infoHeader")}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={3} className={classes.hideSmItem} md={4}>
                          <Typography
                            color="secondary"
                            className={classes.typoStyling}
                          >
                            {t("documents.actionHeader")}
                          </Typography>
                        </Grid>
                            <Grid item xs={4} sm={3} className={classes.hideSmItem}  md={4}>
                            <Typography
                                color="secondary"
                                className={classes.typoStyling}
                            ></Typography>
                            </Grid>
                      </Grid>
                      <ToDoRows
                        items={toDoList}
                        reviewClick={handleReviewClick}
                        uploadClick={handleFileUpload}
                        exampleClick={viewExample}
                        signatureClick={signatureClick}
                        user={user}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

ToDo.propTypes = {
  user: PropTypes.object,
  documents: PropTypes.array,
  viewExample: PropTypes.func,
  reviewDocInfo: PropTypes.func,
  handleFileUpload: PropTypes.func,
  handleTemplateClick: PropTypes.func,
  canShowReport: PropTypes.bool,
  handleSetCanShowReport: PropTypes.func,
  report: PropTypes.array,
  loadReport: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    // documents: state.documents,
    report: state.report,
    selectedAppointmentID: state.appointmentID,
    selectedJurisdictionID: state.jurisdictionID,
    selectedLocationID: state.locationID,
    selectedReportType: state.reportType,
    selectedVehicleID: state.vehicleID,
  };
}

const mapDispatchToProps = {
  // loadReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToDo);
